import { useEffect, useState } from 'react';
import { Button, Dropdown, Select, Space } from 'antd';
import { downloadXlsx } from 'utils/XlsxDownloader';
import { DownOutlined } from '@ant-design/icons';

const ProductListController = ({
  products,
  productCount,
  onDelete,
  onChangeOrder,
  onBulk,
  permission,
  checkedList,
}) => {
  const [order, setOrder] = useState('createdAtDesc');

  useEffect(() => {
    if (order && onChangeOrder) {
      onChangeOrder(order);
    }
  }, [order]);

  const columns = [
    {
      title: '상품구분',
      dataIndex: 'product_category_name',
    },
    {
      title: '상품코드',
      dataIndex: 'product_code',
    },
    {
      title: '상품명',
      dataIndex: 'product_name',
    },
    {
      title: '재고수량',
      dataIndex: 'num',
    },
    {
      title: '판매가',
      dataIndex: 'price',
    },
    {
      title: '판매유형',
      dataIndex: 'type',
    },
    {
      title: '등록일',
      dataIndex: 'created_at',
    },
  ];

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: 20,
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <h4 style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}>
          총 <span>{productCount}</span>건
        </h4>
        <ul style={{ display: 'flex', gap: 8 }}>
          <li
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 5,
            }}
          >
            <Button onClick={onDelete}>선택삭제</Button>
            {permission === 'ADMIN' ? (
              <>
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: 1,
                        label: '진열',
                        onClick: () => onBulk('is_best', 'Y'),
                      },
                      {
                        key: 2,
                        label: '해제',
                        onClick: () => onBulk('is_best', 'N'),
                      },
                    ],
                  }}
                >
                  <Button>
                    <Space>
                      베스트 진열
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: 1,
                        label: '진열',
                        onClick: () => onBulk('is_new', 'Y'),
                      },
                      {
                        key: 2,
                        label: '해제',
                        onClick: () => onBulk('is_new', 'N'),
                      },
                    ],
                  }}
                >
                  <Button>
                    <Space>
                      신상품 진열
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </>
            ) : null}

            <Dropdown
              menu={{
                items: [
                  {
                    key: 1,
                    label: '품절',
                    onClick: () => onBulk('product_status', 'SOLDOUT'),
                  },
                  {
                    key: 2,
                    label: '판매중',
                    onClick: () => onBulk('product_status', 'NORMAL'),
                  },
                  {
                    key: 3,
                    label: '판매종료',
                    onClick: () => onBulk('product_status', 'END'),
                  },
                  {
                    key: 4,
                    label: '판매중지',
                    onClick: () => onBulk('product_status', 'STOP'),
                  },
                  {
                    key: 5,
                    label: '판매대기',
                    onClick: () => onBulk('product_status', 'WAIT'),
                  },
                ],
              }}
            >
              <Button>
                <Space>
                  판매상태변경
                  <DownOutlined />
                </Space>
              </Button>
            </Dropdown>

            {permission === 'ADMIN' ? (
              <Dropdown
                menu={{
                  items: [
                    {
                      key: 1,
                      label: '신청',
                      onClick: () => onBulk('application_status', 'APPLY'),
                    },
                    {
                      key: 2,
                      label: '반려',
                      onClick: () => onBulk('application_status', 'REJECT'),
                    },
                    {
                      key: 3,
                      label: '승인',
                      onClick: () => onBulk('application_status', 'APPROVE'),
                    },
                    {
                      key: 4,
                      label: '대기',
                      onClick: () => onBulk('application_status', 'WAIT'),
                    },
                  ],
                }}
              >
                <Button>
                  <Space>
                    심사상태변경
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
            ) : null}

            <Button
              disabled={products?.length === 0}
              onClick={() =>
                downloadXlsx({
                  columns: [
                    ...columns,
                    {
                      title: '베스트여부',
                      key: 'is_best',
                    },
                    {
                      title: '신상품여부',
                      key: 'is_new',
                    },
                  ],
                  rows: products?.map((product) => ({
                    ...product,
                    product_category_name:
                      product?.product_category?.product_category_name,
                  })),
                  fileName: `상품대시보드`,
                })
              }
            >
              엑셀로 다운로드
            </Button>
            <Button
              disabled={!checkedList?.length}
              onClick={() =>
                downloadXlsx({
                  columns: [
                    ...columns,
                    {
                      title: '베스트여부',
                      key: 'is_best',
                    },
                    {
                      title: '신상품여부',
                      key: 'is_new',
                    },
                  ],
                  rows: products
                    ?.filter((_product) =>
                      checkedList.some(
                        (check) => check.key === _product.product_id,
                      ),
                    )
                    ?.map((product) => ({
                      ...product,
                      product_category_name:
                        product?.product_category?.product_category_name,
                    })),
                  fileName: `상품대시보드`,
                })
              }
            >
              {checkedList?.length}건 엑셀로 다운로드
            </Button>
          </li>
          {/* <li>
            <Select
              value={CONSTANTS.DISPLAY_OPTION[0].value}
              options={CONSTANTS.DISPLAY_OPTION}
            />
          </li>
          <li>
            <Select
              value={CONSTANTS.SALE_OPTION[0].value}
              options={CONSTANTS.SALE_OPTION}
            />
          </li> */}
          {/* <li>
            <Select
              value={''}
              options={[
                {
                  label: '일괄변경',
                  value: '',
                },
                {
                  label: '이벤트 문구',
                  value: '이벤트 문구',
                },
                {
                  label: '구매혜택',
                  value: '구매혜택',
                },
                {
                  label: '수량제한',
                  value: '수량제한',
                },
                {
                  label: '상품정보',
                  value: '상품정보',
                },
                {
                  label: '원산지',
                  value: '원산지',
                },
                {
                  label: '특이사항',
                  value: '특이사항',
                },
              ]}
            />
          </li> */}
          {/* <li>
            <Button>엑셀 다운로드</Button>
          </li> */}
        </ul>
      </div>
      <div>
        <Select
          size='large'
          value={order}
          onChange={(value) => setOrder(value)}
          options={[
            { label: '최신 순', value: 'createdAtDesc' },
            { label: '오래된 순', value: 'createdAtAsc' },
            { label: '높은 가격순', value: 'priceDesc' },
            { label: '낮은 가격순', value: 'priceAsc' },
            // { label: '할인순', value: '할인순' },
          ]}
          style={{
            width: 175,
            marginRight: 8,
          }}
        />
      </div>
    </div>
  );
};

export default ProductListController;
